export default __webpack_public_path__ + "static/img/default_product.f8f7e0d.jpg";